import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { StepDescriptionComponent } from './step-description.component';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    StepDescriptionComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule
  ],
  exports: [
    StepDescriptionComponent
  ]
})
export class StepDescriptionModule { }
